import { Button, ButtonProps, Tooltip } from "antd";

function CustomButton({
  icon,
  onClick,
  loading,
  children,
  type = "default",
  size = "middle",
  tooltip,
  title,
  hidden,
  ...props
}: ButtonProps & { tooltip?: string; title?: string }) {
  const tooltipText = tooltip ?? title;

  return (
    <Tooltip title={tooltipText}>
      <Button
        type={type}
        icon={icon}
        onClick={onClick}
        loading={loading}
        size={size}
        {...props}
        hidden={hidden}
      >
        {children}
      </Button>
    </Tooltip>
  );
}

export default CustomButton;
